<div id="cut-history">
  <csl-data-grid
    [columns]="columns"
    [rows]="data$ | async"
    [disableRowSelectionOnClick]="true"
    [hideFooterPagination]="true"
    [hideFooter]="true"
    [getActions]="getActions"
    [disableColumnFilter]="true"
    (rowClick)="$event.row.stateCuttingTask === errorEnum ? openErrorLogDialog($event.row.log) : null">
  </csl-data-grid>
</div>
